import { render, staticRenderFns } from "./SociosInfoPrimeros.vue?vue&type=template&id=645a71dd&"
import script from "./SociosInfoPrimeros.vue?vue&type=script&lang=js&"
export * from "./SociosInfoPrimeros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports